<template>
  <div class="alert-modal default-modal">
    <ModalHeader @close="$emit('close')" :title="title" />
    <div class="alert-modal__body default-modal__body">
      <span class="alert-modal__subtitle">{{ message }}</span>
      <div class="alert-modal__buttons">
        <ButtonComponent class="alert-modal__btn" variant="gray" size="lg" @click="cancel">
          {{ cancelBtnTitle }}
        </ButtonComponent>
        <ButtonComponent
          v-if="isConfirm"
          ref="confirmBtnRef"
          class="alert-modal__btn alert-modal__btn--confirm"
          variant="red"
          size="lg"
          :loading="loading"
          @click="confirm"
        >
          <span v-if="!loading">{{ confirmBtnTitle }}</span>
        </ButtonComponent>
      </div>
    </div>
  </div>
</template>

<script setup>
/*
 * Модальное окно для уведомлений и подтверждений
 */

/* Imports */
import { onMounted, ref } from "vue";
import { ButtonComponent, ModalHeader } from "@/components/ui";

/* Props */
const props = defineProps({
  title: {
    type: String,
    default: "Уведомление",
    required: true,
  },
  message: {
    type: String,
  },
  isConfirm: {
    type: Boolean,
    default: false,
  },
  center: {
    type: Boolean,
    default: false,
  },
  noBtn: {
    type: Boolean,
    default: false,
  },
  cancelBtnTitle: {
    type: String,
    default: "Закрыть",
  },
  confirmBtnTitle: {
    type: String,
    default: "Да",
  },
  closeEvent: {
    type: String,
    default: "close",
  },
  closeOnConfirm: {
    type: Boolean,
    default: true,
  },
  callback: Function,
  cancelCallback: Function,
  autofocus: {
    type: Boolean,
    default: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["close"]);

/* Refs */
const confirmBtnRef = ref(null);

/* Lifecycle hooks */
onMounted(async () => {
  const el = confirmBtnRef.value?.getInstance();
  if (props.autofocus && el) {
    el.focus();
  }
});

/* Methods */
const cancel = () => {
  if (props.cancelCallback) {
    props.cancelCallback();
  }
  emit(props.closeEvent);
};

const confirm = async () => {
  if (props.callback) {
    await props.callback();
  }
  if (props.closeOnConfirm) {
    emit(props.closeEvent);
  }
};
</script>

<style lang="stylus">
.alert-modal {
  width 100vw
	max-width: 450px

  &__body {
    padding-top 30px
    gap: 30px
  }

  &__subtitle {
    line-height 1.4
  }

	&__buttons {
		width 100%
		display flex
		align-items center
		gap 10px
	}

	&__btn {
		flex 1

		&--confirm:focus {
			outline: none
			box-shadow: 0 0 0 3px var(--red-o3);
		}
	}
}
</style>
